const trackingUtils = require('../utils/tracking.utils');

const ShoppingCart = require('od-modules/cart/cart');

const isAncillaryStepOpenFirstTimeSessionItem = 'isAncillaryStepOpenFirstTime';

const isPrimeWidgetStepOpenFirstTimeSessionItem = 'isPrimeWidgetStepOpenFirstTime';

const $payment = $('#payment');

const ACTION_ADD = 'ADD';

const CATEGORY = 'SERVICE_OPTION';

const $selectors = {
    stepButton: $payment.find('.service_options_step_button'),
    primeStepButton: $payment.find('.ancillaries_step_membership_button'),
    ancillariesModuleContainer: $payment.find('.ancillaries_module_container'),
    ancillariesStepButtonContainer: $payment.find('.ancillaries_step_button_container'),
    stepButtonGroupContainer: $payment.find('.step_button_group_container'),
    specialRequest: $payment.find('#specialrequest'),
};

let warningShown = false;

const isForcedSelectionEnabled = () => {
    return Odigeo.AB.getSupportPackStep === 3;
};

const isAnyServicePackInCart = () => {
    return ShoppingCart.take.serviceOptions().length > 0;
};

const showForcedSelectionMessage = (show) => {
    $payment.find('.service_options_step_warning').toggleClass('odf-hidden', !show);
    warningShown = show;
};

const scrollToNextProduct = () => {
    Odigeo.Utils.scrollToElement($selectors.ancillariesModuleContainer);
};

const handleForcedSelection = () => {
    if (isForcedSelectionEnabled() && !isAnyServicePackInCart()) {
        showForcedSelectionMessage(true);
    } else {
        toggleAncillariesModule(true);
        showForcedSelectionMessage(false);
        scrollToNextProduct();
    }
};

const toggleAncillariesModule = (show) => {
    $selectors.ancillariesModuleContainer.toggleClass('odf-hidden', !show);
    $selectors.stepButtonGroupContainer.toggleClass('odf-hidden', !show);
    $selectors.specialRequest.toggleClass('odf-hidden', !show);
    $selectors.stepButton.toggleClass('odf-hidden', show);
};

const getAncillaryStepOpenFirstTimeSessionItem = () => {
    return Odigeo.Utils.parseJson(Odigeo.Session.get(isAncillaryStepOpenFirstTimeSessionItem));
};

const getPrimeWidgetStepOpenFirstTimeSessionItem = () => {
    return Odigeo.Utils.parseJson(Odigeo.Session.get(isPrimeWidgetStepOpenFirstTimeSessionItem));
};

const isStepClosedByDefault = () => Odigeo._.isNull(getAncillaryStepOpenFirstTimeSessionItem());

const isPrimeStepClosedByDefault = () => Odigeo._.isNull(getPrimeWidgetStepOpenFirstTimeSessionItem());

const isEnabled = () => {
    return $selectors.stepButton.length
        && isStepClosedByDefault()
        && isPrimeStepClosedByDefault()
        && !isAnyServicePackInCart()
        && isForcedSelectionEnabled();
};

const isServiceOption = ({action, data: {category} = {}} = {}) => {
    return action === ACTION_ADD && category === CATEGORY;
};

const onProductChange = (data) => {
    if (isServiceOption(data) && warningShown && !Odigeo.AB.isSupportPackStepLessFrictionEnabled) {
        handleForcedSelection();
    }
};

const trackAncillariesContinueToPayment = () => {
    const ancillariesContinueToPaymentButton = $selectors.ancillariesStepButtonContainer;
    if (ancillariesContinueToPaymentButton.length) {
        trackingUtils.trackEvent('ancillaries_continue_button', 'continue_to_payment_button_ancillaries:onload', 'flights_ancillaries_page');
    }
};

const enable = () => {
    ShoppingCart.whenLoaded.then(() => {
        if (isEnabled()) {
            toggleAncillariesModule(false);
            trackingUtils.trackEvent('ancillaries_continue_button', 'ancillaries_continue_button:onload', 'flights_ancillaries_page');

            $selectors.stepButton.on(Odigeo.Events.tap, (e) => {
                e.stopPropagation();
                handleForcedSelection();
                trackAncillariesContinueToPayment();
            });

            ShoppingCart.subscribe(onProductChange);
        }
    });
};

module.exports = {
    enable,
};
